import { css, cx } from "@emotion/css"
import CircularProgress from "@material-ui/core/CircularProgress"
import { compactSmall } from "routes/Base/Dashboards/RevenueDashboard/helpers/formatters"

const styles = {
  progress: css`
    width: 88px;
    height: 88px;
    display: flex;
    justify-content: center;
    align-items: center;
  `,
}
interface propsTypes {
  percentage: number
  className: string
}
export function CircularProgressWithLabel(props: propsTypes) {
  const { percentage, className } = props
  return (
    <div className={styles.progress}>
      <CircularProgress
        variant="determinate"
        value={100}
        size="88px"
        thickness={2}
        style={{ position: "absolute", color: "var(--extra-dark-grey)" }}
      />
      <CircularProgress
        variant="determinate"
        value={props.percentage}
        size="88px"
        thickness={2}
        className={cx(className)}
      />
      <div
        style={{
          position: "absolute",
          color: "white",
        }}
      >
        {isNaN(percentage) ? "" : `${compactSmall(percentage)}% `}
      </div>
    </div>
  )
}
